
import AllExercise from "../components/AllExercise";

export default function Home() {


    return (
        <div>
            <AllExercise />
        </div>
    )
}
